import {Button, Flex, Image, Text} from '@chakra-ui/react'
import {uniqueId} from 'lodash'
import {CommonColors} from '@utils/CommonStyles'
import {EXAM_BODY_TYPE} from '@pages/ExamPage/examPageModel'
import PersonExamRoomImage from '@assets/images/exam/person-exam-room.png'

function QuestionListItem({data, handleStart}: any) {
  const handleMoveToQuestion = () => {
    handleStart(EXAM_BODY_TYPE.QUESTION)
  }

  return (
    <Flex flex={1}>
      <Flex position={'relative'} w={'600px'} ml={'24px'} display={{ base: 'none', md: 'flex' }}>
        <Image
          maxH={'100%'}
          position={'absolute'}
          bottom={0}
          src={PersonExamRoomImage}
          objectFit={'contain'}
        />
      </Flex>
      <Flex
        w={'100%'}
        alignSelf={'flex-start'}
        justifyContent={'start'}
        mt={'50px'}>
        <Flex
          bgColor={CommonColors.white}
          w={'700px'}
          minH={'500px'}
          borderRadius={24}
          flexDirection={'column'}
          padding={'20px'}>
          <Text fontSize={{base: 24, md: 32, lg: 38}} fontWeight={700} alignSelf={'center'}>
            Danh sách câu hỏi
          </Text>
          {data?.map((e: any, i: number) => (
            <Text
              key={uniqueId(i.toString())}
              fontSize={{base: 16, md: 18, lg: 20}}
              fontWeight={400}
              textAlign={'left'}>
              {`${i + 1}. ${e?.question}`}
            </Text>
          ))}
          <Button
            mt={'30px'}
            w={'92px'}
            alignSelf={'center'}
            borderRadius={'16px'}
            bg={CommonColors.blue2}
            _hover={{bg: CommonColors.blue}}
            color={CommonColors.white}
            fontWeight={700}
            onClick={handleMoveToQuestion}>
            Bắt đầu
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default QuestionListItem
